import { Box, IconButton, SxProps, Theme } from '@mui/material';
import { CaretDown, CaretUp } from 'phosphor-react';
import { useEffect, useMemo, useRef, useState } from 'react';

type DropdownProps = {
  containerStyle?: SxProps<Theme>;
  itemsContainerStyle?: SxProps<Theme>;
  LeftHeaderComponent?: JSX.Element;
  Header: JSX.Element;
  items: any[];
  renderItem: (value: unknown, index?: number) => JSX.Element | null;
  EmptyListComponent?: JSX.Element;
  BottomComponent?: JSX.Element | false;
  border?: boolean;
  boxShadow?: boolean;
};

export const Dropdown = ({
  containerStyle,
  itemsContainerStyle,
  items,
  renderItem,
  LeftHeaderComponent,
  Header,
  EmptyListComponent,
  BottomComponent,
  border = true,
  boxShadow = true,
}: DropdownProps) => {
  const headerRef = useRef<any>(null);
  const [headerHeight, setHeaderHeight] = useState('unset');
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (headerRef.current) {
      const height = headerRef.current.clientHeight;

      setHeaderHeight(height + 'px');
    }
  }, []);

  const getContent = () => {
    if (items.length) {
      return items.map(renderItem);
    } else {
      return EmptyListComponent;
    }
  };

  return (
    <Box
      sx={{
        padding: '12px 16px',
        border: !!border ? '1px solid #E3DDE6' : '',
        gap: '10px',
        borderRadius: '4px',
        backgroundColor: 'white',
        boxShadow: !!boxShadow ? '0px 2px 8px 0px #00000014' : '',
      }}
    >
      <Box sx={{ display: 'flex', gap: '24px', ...containerStyle }}>
        {!!LeftHeaderComponent && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: headerHeight,
            }}
          >
            {LeftHeaderComponent}
          </Box>
        )}
        <Box flex={1}>
          <Box
            ref={headerRef}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {Header}
            <IconButton
              aria-label='close'
              onClick={() => setCollapsed(!collapsed)}
              sx={{
                marginLeft: '39px',
                color: theme => theme.palette.grey[500],
              }}
            >
              {!!collapsed ? (
                <CaretUp size={16} color='#655C68' />
              ) : (
                <CaretDown size={16} color='#655C68' />
              )}
            </IconButton>
          </Box>

          {!!collapsed && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                marginTop: '24px',
                ...itemsContainerStyle,
              }}
            >
              {getContent()}
              {BottomComponent}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
